import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { settings } from './setup';

/**
 * Send an email to a publisher regarding a specific ap
 * @param {object} params - An object of params
 * @param {string} params.accessToken - User IMS token
 * @param {string} params.name - Sender name
 * @param {string} params.company - Sender company name
 * @param {string} params.email - Sender email
 * @param {string} params.appId - Publisher app ID
 * @param {string} params.message - Email body
 * @param {boolean} [params.isSupportRequest] - If the email is a support request
 *
 */
export default async (params = {}, signal = null) => {
  const requiredParams = ['accessToken', 'appId', 'company', 'message'];
  const paramsRules = {
    appId: { allowedTypes: ['string'] },
    accessToken: { allowedTypes: ['string'] },
    company: { allowedTypes: ['string'] },
    message: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(`${settings.endpoint}/v2/support/sendEmail`, {
    signal,
    method: 'POST',
    headers: {
      'x-api-key': settings.apiKey,
      'Content-type': 'application/json',
      Authorization: params.accessToken,
    },
    body: JSON.stringify({
      appId: params.appId,
      senderCompany: params.company,
      message: params.message,
      templateName: 'CONTACT_PUBLISHER_TEMPLATE',
      isSupportRequest: params.isSupportRequest || false,
    }),
  });
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }
  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return true;
  }
};
